/**
 * 테마/가로스크롤 섹션에 노출되는 정보를 운영툴에서 제어하기 위한 목적의 필드입니다.
 * 만약 해당 섹션에서 이 값이 null / undefined 라면 아무것도 노출하지 않습니다
 * 참고(위키) : https://podotree.atlassian.net/wiki/spaces/PSD/pages/2741797501/VO#MetaInfoType
 * 참고(API) : https://github.kakaocorp.com/kakaopage/karina/blob/develop/modules/karina-core/src/main/kotlin/com/kakaopage/karina/model/enums/CardViewType.kt#L7-L7
 */
export enum MetaInfoTypeVo {
  ViewCount = 'VIEW_COUNT',
  AuthorName = 'AUTHOR_NAME',
  IssueStatus = 'ISSUE_STATUS',
  RecommendReason = 'RECOMMEND_REASON',
  // 헬릭스 테마 섹션에서 추가
  CategoryAuthor = 'CATEGORY_AUTHOR',
  CategoryViewCount = 'CATEGORY_VIEW_COUNT',
}
